import Vue from 'vue'
import Vuex from 'vuex'

import feathers from '@/feathers/'
import { errorMessages } from '@/i18n/'

import users from '@/store/users'
import clients from '@/store/clients'
import settings from '@/store/settings'
import datasets from '@/store/datasets'
import flyers from '@/store/flyers'
import downloads from '@/store/downloads'
import dictionary from '@/store/dictionary'

import Cookies from 'cookies-js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    users, clients, settings, datasets, flyers, downloads, dictionary
  },
  state: {
    feathers: feathers,
    loading: false,
    fetching: false,
    auth: {
      user: null,
      token: null
    },
    snacks: {
      messages: [],
      visible: false
    },
    app: {
      light: true,
      clipped: true,
      fixed: true,
      drawer: false,
      mini: false,
      menuItems: [
        { icon: 'home', title: 'Index', link: '/' },
        // { icon: 'vpn_key', title: 'Login', link: '/login/', auth: false },
        { icon: 'library_books', title: 'Flyere', link: '/flyere/' },
        { icon: 'dashboard', title: 'Dashboard', link: '/dashboard/', auth: true }
      ],
      routes: [
        { path: '/comunitatea-locala', meta: { index: 0, trans: 'ov-tab-titlu', page: 'overview', subtrans: null } },
        { path: '/buget-general-centralizat/bgc-rezumat', meta: { index: 1, trans: 'bgc-tab-titlu', page: 'bgc', subtrans: 'bgc-tab-general' } },
        { path: '/buget-general-centralizat/bgc-structura', meta: { index: 2, trans: 'bgc-tab-titlu', page: 'bgc', subtrans: 'bgc-tab-defalcat' } },
        { path: '/buget-general-centralizat/bgc-nivel-realizat', meta: { index: 3, trans: 'bgc-tab-titlu', page: 'bgc', subtrans: 'bgc-tab-tabel' } },
        { path: '/buget-local/bl-rezumat', meta: { index: 4, trans: 'bl-tab-titlu', page: 'bl', subtrans: 'bl-tab-general' } },
        { path: '/buget-local/bl-venituri', meta: { index: 5, trans: 'bl-tab-titlu', page: 'bl', subtrans: 'bl-tab-venituri' } },
        { path: '/buget-local/bl-cheltuieli-functionale', meta: { index: 6, trans: 'bl-tab-titlu', page: 'bl', subtrans: 'bl-tab-ch-fct' } },
        { path: '/buget-local/bl-cheltuieli-economice', meta: { index: 7, trans: 'bl-tab-titlu', page: 'bl', subtrans: 'bl-tab-ch-ec' } },
        { path: '/buget-local/bl-tabel-cheltuieli', meta: { index: 8, trans: 'bl-tab-titlu', page: 'bl', subtrans: 'bl-tab-matrice' } },
        { path: '/contributia-cetateanului', meta: { index: 9, trans: 'cc-tab-titlu', page: 'cc', subtrans: null } }
      ]
    },
    client: {
      data: null,
      timespans: [],
      dataset: null
    },
    excel: null,
    services: {
      users: feathers.service('users'),
      clients: feathers.service('clients'),
      datasets: feathers.service('datasets'),
      settings: feathers.service('settings'),
      xlsx: feathers.service('xlsx'),
      excel: feathers.service('excel'),
      flyers: feathers.service('flyers'),
      downloads: feathers.service('downloads'),
      dictionar: feathers.service('dictionar'),
      dictionary: feathers.service('dictionary')
    },
    settingsObject: null,
    year: null,
    quarter: null,
    setBLTabArcId: null
  },
  getters: {
    snacksVisible: state => state.snacks.visible,
    snacksMessages: state => state.snacks.messages,
    appLight: state => state.app.light,
    appFixed: state => state.app.fixed,
    appDrawer: state => state.app.drawer,
    appMini: state => state.app.mini,
    appClipped: state => state.app.clipped,
    appMenuItems: state => state.app.menuItems,
    getUser: state => state.auth.user,
    getLoading: state => state.loading,
    getFetching: state => state.fetching,
    client: state => state.client,
    getIndexDataset: state => state.client.dataset,
    getExcelExists: state => !!state.excel,
    getExcelBGC: state => state.excel ? state.excel.BGC : null,
    getExcelBGCBugete: state => state.excel ? state.excel.BGC.bugete : null,
    getExcelBGCGeneral: state => state.excel ? state.excel.BGC.general : null,
    getExcelBGCVenCh: state => state.excel ? state.excel.BGC.vench : null,
    getExcelBGCDefalcat: state => state.excel ? state.excel.BGC.defalcat : null,
    getExcelBGCTable: state => state.excel ? state.excel.BGC.table : null,
    getExcelBL: state => state.excel ? state.excel.BL : null,
    getExcelBLGeneral: state => state.excel ? state.excel.BL.general : null,
    getExcelBLVenituri: state => state.excel ? state.excel.BL.venituri : null,
    getExcelBLChFct: state => state.excel ? state.excel.BL.chfct : null,
    getExcelBLChEc: state => state.excel ? state.excel.BL.chec : null,
    getExcelBLMatrice: state => state.excel ? state.excel.BL.matrice : null,
    getExcelCC: state => state.excel ? state.excel.CC : null,
    getExcelRezumat: state => state.excel ? state.excel.rezumat : null,
    getExcelTextOverview: state => state.excel ? state.excel.text['OVERVIEW'] : null,
    getExcelTextCC: state => state.excel ? state.excel.text['Contributia Cetateanului'] : null,
    getExcelTextBLMatrice: state => state.excel ? state.excel.text['BL Matrice'] : null,
    getExcelTextBLChEc: state => state.excel ? state.excel.text['BL Cheltuieli EC'] : null,
    getExcelTextBLChFct: state => state.excel ? state.excel.text['BL Cheltuieli FCT'] : null,
    getExcelTextBLVenituri: state => state.excel ? state.excel.text['BL Venituri'] : null,
    getExcelTextBLGeneral: state => state.excel ? state.excel.text['BL General'] : null,
    getExcelTextBGCStructura: state => state.excel ? state.excel.text['BGC Structura si Nivel Realizat'] : null,
    getExcelTextBGCBugete: state => state.excel ? state.excel.text['BGC Bugete si Institutii'] : null,
    getExcelTextBGCVenCh: state => state.excel ? state.excel.text['BGC Venituri si Cheltuieli'] : null,
    getExcelTextBGCGeneral: state => state.excel ? state.excel.text['BGC General'] : null,
    getExcelPopups: state => state.excel ? state.excel.popups : null,
    getInstitutions: state => state.client.dataset ? state.client.dataset.institutions : null,
    getFunctional: state => state.client.dataset ? state.client.dataset.functional : null,
    getColors: state => state.client.data ? state.client.data.colors : null,
    getSettingsObject: state => state.settingsObject,
    getBLTabArcId: state => state.setBLTabArcId,
    getRoutes: state => state.app.routes,
    getExcelLegendPopupsvenituri: state => state.excel ? state.excel.popups['Donut Venituri'] || [] : null,
    'getExcelLegendPopupscheltuieli-fct': state => state.excel ? state.excel.popups['Donut ChFct'] || [] : null,
    'getExcelLegendPopupscheltuieli-ec': state => state.excel ? state.excel.popups['Donut ChEc'] || [] : null,
    'getExcelLegendPopupscc': state => []
  },
  mutations: {
    setLoading (state, data) {
      state.loading = data
    },
    setFetching (state, data) {
      state.fetching = data
    },
    setAuth (state, data) {
      state.auth.token = data.token
      state.auth.user = data.user
      state.auth.error = null
      state.loading = false
    },
    setSnack (state, data) {
      data.message = data.meta.error ? (data.code ? errorMessages[data.code] : data.message) : data.message
      state.snacks.messages.push(data)
      state.snacks.visible = true
    },
    toggleSnacks (state, value) {
      state.snacks.visible = value
    },
    removeSnack (state) {
      state.snacks.messages.splice(0, 1)
    },
    toggleLight (state) {
      state.app.light = !state.app.light
    },
    setLight (state, payload) {
      state.app.light = !!payload
    },
    closeDrawer (state) {
      state.app.drawer = false
    },
    openDrawer (state) {
      state.app.drawer = true
    },
    toggleMini (state) {
      state.app.mini = !state.app.mini
    },
    clearMessages (state) {
      state.snacks.messages = []
      state.snacks.visible = false
    },
    setClient (state, client) {
      Vue.set(state.client, 'data', client)
    },
    setTimespans (state, timespans) {
      Vue.set(state.client, 'timespans', timespans)
    },
    setIndexDataset (state, dataset) {
      // state.client.dataset = dataset
      Vue.set(state.client, 'dataset', dataset)
    },
    setExcel (state, data) {
      Vue.set(state, 'excel', data)
    },
    setSettingsObject (state, payload) {
      state.settingsObject = payload
    },
    setYearQuarter (state, payload) {
      state.year = payload.year
      state.quarter = payload.quarter
    },
    setBLTab (state, payload) {
      state.BLTab = payload
    },
    setBLTabArcId (state, payload) {
      state.setBLTabArcId = payload
    }
  },
  actions: {
    login ({commit, dispatch}, data) {
      commit('setLoading', true)
      return feathers.authenticate({
        strategy: 'local',
        email: data.email,
        password: data.password
      })
      .then(response => {
        return grabAuthData(response, commit, dispatch)
      })
      .catch(error => {
        error.meta = { error: true, success: false, info: false, warning: false }
        commit('setSnack', error)
        commit('setLoading', false)
      })
    },
    logout ({commit}) {
      commit('setLoading', true)
      feathers.logout()
        .then(response => {
          commit('setAuth', {token: null, user: null})
          commit('clearUsers')
          commit('setLoading', false)
          commit('setSnack', {
            message: 'Sesiunea de lucru a fost inchisa. Sunteti in modul anonim.',
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
          commit('setLoading', false)
        })
    },
    attemptAuth ({commit, dispatch, state}) {
      feathers.passport.getJWT()
        .then(jwt => {
          if (jwt) {
            return state.feathers.authenticate({strategy: 'jwt', accessToken: jwt})
          }
          Promise.resolve(null)
        })
        .then(response => {
          if (response) {
            return grabAuthData(response, commit, dispatch)
          } else {
            commit('setLoading', false)
          }
          return Promise.resolve(null)
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
          commit('setLoading', false)
        })
    },
    getClientData ({commit, state}, id) {
      if (state.client.data && id === state.client.data._id) return

      let lang = Cookies.get('bgt-lang')
      let languageSet = false

      if (lang) {
        languageSet = true
      } else if (!lang && navigator.language) {
        languageSet = false
        lang = 'RO'
      }
      commit('setLanguage', {lang, languageSet})
      commit('setLoading', true)

      // if (state.client.data && id === state.client.data._id) return

      state.services.clients.get(id)
        .then(result => {
          commit('setClient', result)
          return state.services.datasets
            .find({
              query: {
                clientID: result._id,
                $select: ['year', 'quarter', 'approved', 'draft', 'clientID'],
                $sort: {
                  year: -1,
                  quarter: -1
                },
                paginate: false
              }
            })
        })
        .then(result => {
          // if (!state.client.data || id !== state.client.data._id) {
          commit('setTimespans', result)
          // }
          commit('setLoading', false)
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
          commit('setLoading', false)
        })
    },
    fetchIndexDataset ({commit, state}, id) {
      commit('setLoading', true)
      state.services.datasets.get(id)
        .then(result => {
          commit('setIndexDataset', result)
          return state.services.excel.find({
            query: {
              datasetId: id
            }
          })
        })
        .then(result => {
          // console.log(result)
          commit('setExcel', result.data.length ? result.data[0] : null)
          return state.services.settings.find({
            query: {
              year: state.year,
              quarter: state.quarter
            }
          })
        })
        .then(result => {
          commit('setSettingsObject', result.data.length ? result.data[0] : null)
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setLoading', false)
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
          commit('setLoading', false)
        })
    },
    uploadFile ({commit, state}, data) {
      commit('setLoading', true)
      state.services.xlsx.create(data)
        .then(result => {
          // console.log(result)
          // console.log(JSON.stringify(result))
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setLoading', false)
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
          commit('setLoading', false)
        })
    }
  }
})

function grabAuthData (response, commit, dispatch) {
  return feathers.passport.verifyJWT(response.accessToken)
    .then(result => feathers.service('users').get(result.userId))
    .then(data => {
      commit('setAuth', {token: response.accessToken, user: data})
      commit('setSnack', {
        message: 'Autentificare reusita. Sesiune de lucru pornita.',
        meta: {
          error: false,
          success: true,
          info: false,
          warning: false
        }
      })
      dispatch('setEventWatchers')
    })
    .catch(error => {
      console.log(error)
      error.meta = { error: true, success: false, info: false, warning: false }
      commit('setSnack', error)
      commit('setLoading', false)
    })
}



// WEBPACK FOOTER //
// ./src/store/index.js